import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as SurveyJSCreator from 'survey-creator';
import * as SurveyKo from 'survey-knockout';
import 'survey-creator/survey-creator.css';

import 'jquery-ui/themes/base/all.css';
import 'nouislider/distribute/nouislider.css';
import 'select2/dist/css/select2.css';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';

import 'jquery-bar-rating/dist/themes/css-stars.css';
import 'jquery-bar-rating/dist/themes/fontawesome-stars.css';

import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'select2/dist/js/select2.js';
import 'jquery-bar-rating';

import 'icheck/skins/square/blue.css';

import * as widgets from 'surveyjs-widgets';

SurveyJSCreator.StylesManager.applyTheme('default');

widgets.icheck(SurveyKo, $);
widgets.select2(SurveyKo, $);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo, $);
widgets.jqueryuidatepicker(SurveyKo, $);
widgets.nouislider(SurveyKo);
widgets.select2tagbox(SurveyKo, $);
widgets.signaturepad(SurveyKo);
widgets.sortablejs(SurveyKo);
widgets.ckeditor(SurveyKo);
widgets.autocomplete(SurveyKo, $);
widgets.bootstrapslider(SurveyKo);

const SurveyCreator = ({ data, onEditFinish }) => {
  let surveyCreator;

  const saveMySurvey = () => {
    onEditFinish({
      id: data.id,
      data: surveyCreator.text,
    });
  };

  useEffect(() => {
    const options = { showEmbededSurveyTab: true };
    surveyCreator = new SurveyJSCreator.SurveyEditor(
      'surveyCreatorContainer',
      options,
    );
    surveyCreator.saveSurveyFunc = saveMySurvey;
    surveyCreator.changeText(data.assessment);
  }, []);

  return <div id="surveyCreatorContainer" />;
};

SurveyCreator.propTypes = {
  data: PropTypes.object,
  onEditFinish: PropTypes.func,
};

export default SurveyCreator;
